import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Button from "@mui/material/Button"; // eslint-disable-line no-unused-vars
import emailIcon from "../assets/new icons/Email Icon.svg";
import passwordIcon from "../assets/new icons/Password Icon.svg";
import rightArrowIcon from "../assets/new icons/extraction review/right arrow.svg";
import { activeBrandTheme } from "../components/Constants/brandTheme";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputBase from "@mui/material/InputBase";
import { Typography, Box, Paper } from "@mui/material";
import { useSharedValue } from "../components/Constants/constants";
import { useUserSettings } from "../contexts/UserSettingsContext";
import { BASE_URL, appVersion } from "../App_Settings/app_settings";
import "./Login.css";
import "../components/Constants/config.css";

const ComplyLogin = () => {
  const history = useHistory();
  const [username, setUsername] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState("");
  const { updateDirectNavigation } = useSharedValue();
  const { handleNotificationList } = useSharedValue();
  const { handleSelectedRows } = useSharedValue();
  const [pageLoaded, setPageLoaded] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { refreshSettings } = useUserSettings();

  document.addEventListener("contextmenu", (event) => event.preventDefault());

  const onChange = (e) => {
    const { name, value } = e.target;
    if (name === "username") setUsername(value);
    if (name === "password") setPassword(value);
  };

  const handlePasswordReset = () => {
    history.push("/passwordReset");
  };

  useEffect(() => {
    setPageLoaded(true);
  }, []);

  const doLogin = async (forceLogin = false) => {
    setIsLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/users/authenticate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ Username: username, Password: password, ForceLogin: forceLogin }),
      });

      const data = await response.json();

      if (response.status === 409 && data.errorCode === "SESSION_LIMIT_REACHED") {
        setIsLoading(false);
        const confirmForce = window.confirm(
          `${data.message}\n\nDo you want to terminate the other session(s) and log in here?`
        );
        if (confirmForce) await doLogin(true);
        return;
      }

      if (data.userId !== undefined) {
        if (data.showMFAScreen === true) {
          sessionStorage.setItem("mfaToken", data.mfaToken || "");
          sessionStorage.setItem("mfaUserId", data.userId || "");
          sessionStorage.setItem("showEmail", data.showEmail ? "true" : "false");
          sessionStorage.setItem("showPhone", data.showPhone ? "true" : "false");
          sessionStorage.setItem("mobileNumber", data.mobileNumber || "");
          sessionStorage.setItem("mfaFirstName", data.firstName || "");
          setIsLoading(false);
          history.push({ pathname: "/mfa-verify", state: { someValue: true } });
        } else {
          localStorage.setItem("token", JSON.stringify(data));
          if (data.sessionToken) localStorage.setItem("sessionToken", data.sessionToken);
          updateDirectNavigation(true);
          localStorage.removeItem("SelectedFilesList");
          localStorage.removeItem("notifications_list");
          handleNotificationList([]);
          handleSelectedRows([]);
          if (refreshSettings) await refreshSettings();
          setIsLoading(false);
          history.push({ pathname: "/dashboard", state: { someValue: true } });
        }
      } else {
        if (data.requiresVerification) {
          setIsLoading(false);
          if (!data.isMobileVerified) sessionStorage.setItem("pendingMobileOtp", "1");
          history.push({
            pathname: "/verify-account",
            state: {
              email: data.email || username,
              firstName: "",
              isEmailVerified: data.isEmailVerified || false,
              isMobileVerified: data.isMobileVerified || false,
            },
          });
          return;
        }
        setIsLoading(false);
        alert(data.message || "An error occurred. Please try again.");
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error during authentication", error);
      alert("An error occurred. Please try again.");
    }
  };

  const submitForm = async (e) => {
    if (!username || !password) {
      setIsLoading(false);
      alert("Username and Password are mandatory fields. Please enter both and try again.");
      return;
    }
    e.preventDefault();
    await doLogin(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") submitForm(e);
  };

  if (!pageLoaded) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          backgroundImage: "url(/background.png)",
        }}
      >
        <CircularProgress style={{ color: "#fff" }} size={40} />
      </div>
    );
  }

  return (
    <div className="login-page">
      <Box
        sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Paper
          elevation={3}
          sx={{ p: 4, borderRadius: 4, bgcolor: "#fff", maxWidth: 420, width: "100%", mx: 2 }}
        >
          <Box sx={{ textAlign: "center", mb: 3 }}>
            <Box sx={{ mb: 2, display: "flex", justifyContent: "center" }}>
              <img
                src={activeBrandTheme.logos.login}
                alt={activeBrandTheme.logos.sidebarAlt}
                style={{ height: "40px" }}
              />
            </Box>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography
              variant="body2"
              sx={{
                color: "#6A6A6B",
                mb: 0.75,
                fontSize: "14.33px",
                fontFamily: "Poppins, sans-serif",
                fontWeight: 400,
              }}
            >
              Email Address
            </Typography>
            <InputBase
              type="text"
              name="username"
              value={username}
              onChange={onChange}
              placeholder="Please enter your email"
              autoComplete="off"
              inputProps={{ autoComplete: "off" }}
              fullWidth
              startAdornment={
                <InputAdornment position="start">
                  <img src={emailIcon} alt="email" className="application-login-input-icon" />
                </InputAdornment>
              }
              sx={{
                bgcolor: "#ffffff",
                borderRadius: "3.56px",
                border: "0.89px solid #DDDDDD",
                px: "10.68px",
                height: "42.73px",
                fontSize: "14.33px",
                fontFamily: "Poppins, sans-serif",
                color: "#6A6A6B",
                "& .MuiInputAdornment-positionStart": { marginRight: 0 },
                "& input": { padding: 0, outline: "none" },
                "& input::placeholder": { color: "#6A6A6B" },
                "&.Mui-focused": { border: "0.89px solid #DDDDDD" },
                "& input:-webkit-autofill": {
                  WebkitBoxShadow: "0 0 0 1000px #ffffff inset",
                  WebkitTextFillColor: "#6A6A6B",
                  transition: "background-color 5000s ease-in-out 0s",
                },
                "& input:-webkit-autofill:hover": {
                  WebkitBoxShadow: "0 0 0 1000px #ffffff inset",
                  WebkitTextFillColor: "#6A6A6B",
                },
                "& input:-webkit-autofill:focus": {
                  WebkitBoxShadow: "0 0 0 1000px #ffffff inset",
                  WebkitTextFillColor: "#6A6A6B",
                },
              }}
            />
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography
              variant="body2"
              sx={{
                color: "#6A6A6B",
                mb: 0.75,
                fontSize: "14.33px",
                fontFamily: "Poppins, sans-serif",
                fontWeight: 400,
              }}
            >
              Password
            </Typography>
            <InputBase
              type={showPassword ? "text" : "password"}
              name="password"
              value={password}
              onChange={onChange}
              placeholder="Please enter your password"
              onKeyDown={handleKeyDown}
              autoComplete="new-password"
              inputProps={{ autoComplete: "new-password" }}
              fullWidth
              startAdornment={
                <InputAdornment position="start">
                  <img src={passwordIcon} alt="password" className="application-login-input-icon" />
                </InputAdornment>
              }
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                    size="small"
                  >
                    {showPassword ? (
                      <Visibility className="application-visibility-icon" />
                    ) : (
                      <VisibilityOff className="application-visibility-icon" />
                    )}
                  </IconButton>
                </InputAdornment>
              }
              sx={{
                bgcolor: "#ffffff",
                borderRadius: "3.56px",
                border: "0.89px solid #DDDDDD",
                px: "10.68px",
                height: "42.73px",
                fontSize: "14.33px",
                fontFamily: "Poppins, sans-serif",
                color: "#6A6A6B",
                "& .MuiInputAdornment-positionStart": { marginRight: 0 },
                "& input": { padding: 0, outline: "none" },
                "& input::placeholder": { color: "#6A6A6B" },
                "&.Mui-focused": { border: "0.89px solid #DDDDDD" },
                "& input:-webkit-autofill": {
                  WebkitBoxShadow: "0 0 0 1000px #ffffff inset",
                  WebkitTextFillColor: "#6A6A6B",
                  transition: "background-color 5000s ease-in-out 0s",
                },
                "& input:-webkit-autofill:hover": {
                  WebkitBoxShadow: "0 0 0 1000px #ffffff inset",
                  WebkitTextFillColor: "#6A6A6B",
                },
                "& input:-webkit-autofill:focus": {
                  WebkitBoxShadow: "0 0 0 1000px #ffffff inset",
                  WebkitTextFillColor: "#6A6A6B",
                },
              }}
            />
          </Box>

          <Box sx={{ textAlign: "right", mb: 3 }}>
            <Typography
              variant="body2"
              onClick={handlePasswordReset}
              className="forgot-password-link"
            >
              Forgot Password?
            </Typography>
          </Box>

          <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
            <Button
              onClick={submitForm}
              variant="contained"
              disabled={isLoading}
              sx={{
                bgcolor: "var(--btn-primary-bg)",
                color: "var(--btn-primary-text)",
                fontWeight: 700,
                borderRadius: 2,
                fontSize: "14.33px",
                width: "200px",
                px: 3,
                py: 1,
                textTransform: "none",
                "&:hover": { bgcolor: "var(--btn-primary-bg)" },
              }}
            >
              {isLoading ? (
                <CircularProgress size={20} sx={{ color: "var(--btn-primary-text)" }} />
              ) : (
                <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                  <Box sx={{ flex: 1 }} />
                  <span>Sign in</span>
                  <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
                    <img
                      src={rightArrowIcon}
                      alt=""
                      style={{ width: 12, height: 12, filter: "brightness(0) invert(1)" }}
                    />
                  </Box>
                </Box>
              )}
            </Button>
          </Box>
        </Paper>
      </Box>

      <Box
        sx={{
          position: "fixed",
          bottom: 10,
          right: 14,
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-end",
          gap: "6px",
          pointerEvents: "none",
        }}
      >
        {/* <img
          src={require("../assets/new icons/Powered By Comply Exchange (White) (1).png")}
          alt="Powered by Comply Exchange"
          style={{ height: 26, objectFit: "contain" }}
        /> */}
        <span style={{ color: "#ffffff", fontSize: "12px" }}>VERSION: {appVersion}</span>
      </Box>
    </div>
  );
};

export default ComplyLogin;
